import { properties } from '../properties.js';
import React, { Component } from 'react';
import Web3 from 'web3';
import NavBar from '../navbar.js';
import Footer from '../footer.js';
import i18n from '../I18N/I18n.js'; 
import Cookies from 'js-cookie';
import standard_abi from '../../abis/DPP-abi.json';
import Swal from 'sweetalert2';
import QRCode from "react-qr-code";
import { withTranslation } from 'react-i18next';
import { logout, apiSecuredRequest, setBearer, isUserOrWallet, isRootWallet, imprimirQR} from '../functions.js';
import '../css/DPP16.css';




class DPPDisplay extends Component {

    async componentDidMount() {
        // 1. Carga de Web3
        const bearer = await this.checkIfWeb3UserOrLoginUser();
        await this.loadCertificate(bearer);
       
        // 2. Carga de datos de la Blockchain

      //  await this.cargarCamposMarca()
    }

   cambiarIdioma = (idioma) => {
           const { i18n } = this.props;
           i18n.changeLanguage(idioma);
           Cookies.set('idiomaPreferido', idioma, { expires: 365 }); // Guarda la preferencia por un año // Cambia el idioma usando i18n
       };

    logout = async () => {
        this.setState({bearer: null});
        this.setState({email: null});
        logout();
    }

    async checkIfWeb3UserOrLoginUser() { 
        let params = (new URL(document.location)).searchParams;
        this.setState({saleDate: new Date()})
        const certificadoId = params.get("certificadoId");
        this.setState({ certificadoId: certificadoId })
        const certificadoName = params.get("certificadoName");
        this.setState({certificadoName})
       
       
        
        const email = Cookies.get("email");
        this.setState({ email: email });
		
        const bearer = Cookies.get("id");
        this.setState({ bearer: bearer });
        const userRol = Cookies.get("rol");

        this.setState({ userRol: userRol });
        let bearerVar;
        const urlInfo = window.location.pathname.split("/")
       
        this.setState({ empresaMapping: urlInfo[1] })
        const idLinea = params.get("idLinea");
        const DPPQRCode = `${properties.clientApp}/${urlInfo[1]}/DPP16/QRDPP?idLinea=${encodeURIComponent(idLinea)}&certificadoId=${certificadoId}`;
        this.setState({QRCode: DPPQRCode})
        bearerVar = Cookies.get("id");
        let account = await isUserOrWallet(email, bearerVar);
        const isRootDir = await isRootWallet(account);
        this.setState({isRootDir: isRootDir});

        this.setState({account})
        const bearerToken = await setBearer(email, bearerVar, account);
        this.setState({bearer: bearerToken})
        return bearerToken;
    }

    async loadCertificate(bearer) {

		let camposData = JSON.stringify({
			"certificadoId": `${this.state.certificadoId}`,
			"tipoStandard": `DPP16`
		});


		const campos = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/campo/getCampos`, camposData, bearer);
		this.setState({ campos: campos.data })
	
		let web3;
		
		let params = (new URL(document.location)).searchParams;
		const abi = standard_abi
        
    const certificado = JSON.parse(localStorage.getItem('certificado'));
    const direccion = certificado.direccion;
    const direccion2 = certificado.direccion2;
    this.setState({direccion: direccion})
    this.setState({direccion2: direccion2})
		let ercIdVar;
		let nftSeleccionadoVar;

		if(abi && direccion && direccion2) {
			
			try{
				
				if(this.state.account != 0) {
					web3 = window.web3;


                    const contractA = new web3.eth.Contract(abi, direccion);
                    const contractB = new web3.eth.Contract(abi, direccion2);
                    this.setState({contractA});
                    		 
                   
                    const idLinea = params.get("idLinea");
                    const ownerCertificatesP2 = await contractA.methods.getOwnerStandardData(idLinea).call({ from: properties.proofUHostWallet });

                    const ownerCertificatesP2B = await contractB.methods.getOwnerStandardData(idLinea).call({ from: properties.proofUHostWallet });
                   

                   //LOG IN
                   nftSeleccionadoVar = {
                    id: ownerCertificatesP2.id,
                    idLinea: ownerCertificatesP2[0].idLinea,
                    campo0: ownerCertificatesP2[0].campo0,
                    campo1: ownerCertificatesP2[0].campo1,
                    campo2: ownerCertificatesP2[0].campo2,
                    campo3: ownerCertificatesP2[0].campo3,
                    campo4: ownerCertificatesP2[0].campo4,
                    campo5: ownerCertificatesP2[0].campo5,
                    campo6: ownerCertificatesP2B[0].campo0,
                    campo7: ownerCertificatesP2B[0].campo1,
                    campo8: ownerCertificatesP2B[0].campo2,
                    campo9: ownerCertificatesP2B[0].campo3,
                    campo10: ownerCertificatesP2B[0].campo4,
                    campo11: ownerCertificatesP2B[0].campo5
                  };
                   
                   this.setState({ selectedNFT: nftSeleccionadoVar })
					
				}else{

					
					 web3 = new Web3(new Web3.providers.HttpProvider(properties.web3Provider));
					
           const contractA = new web3.eth.Contract(abi, direccion);
           const contractB = new web3.eth.Contract(abi, direccion2);
           this.setState({contractA});
           this.setState({contractB});
									 
                    
					 const idLinea = params.get("idLinea");
           const ownerCertificatesP2 = await contractA.methods.getOwnerStandardData(idLinea).call({ from: properties.proofUHostWallet });

                   
           const ownerCertificatesP2B = await contractB.methods.getOwnerStandardData(idLinea).call({ from: properties.proofUHostWallet });
                   

           //LOG IN
           nftSeleccionadoVar = {
            id: ownerCertificatesP2.id,
            idLinea: ownerCertificatesP2[0].idLinea,
            campo0: ownerCertificatesP2[0].campo0,
            campo1: ownerCertificatesP2[0].campo1,
            campo2: ownerCertificatesP2[0].campo2,
            campo3: ownerCertificatesP2[0].campo3,
            campo4: ownerCertificatesP2[0].campo4,
            campo5: ownerCertificatesP2[0].campo5,
            campo6: ownerCertificatesP2B[0].campo0,
            campo7: ownerCertificatesP2B[0].campo1,
            campo8: ownerCertificatesP2B[0].campo2,
            campo9: ownerCertificatesP2B[0].campo3,
            campo10: ownerCertificatesP2B[0].campo4,
            campo11: ownerCertificatesP2B[0].campo5
          };
           
           
           this.setState({ selectedNFT: nftSeleccionadoVar })

				}


			}catch (err) {
				this.setState({ errorMessage: err })
			}
		}else{
			Swal.fire({
				title: `${i18n.t('certificatesError')}`,
				icon: 'error',
				showCancelButton: false,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "OK"
				}).then((result) => {
					if (result.isConfirmed) {
						window.locationbar.href = "/"
					}else  if(result.dismiss){
						window.locationbar.href = "/"
					}
				 
				})
			  window.locationbar.href = "/"
			

		}

		this.setState({loading: false});

	}

    constructor(props) {
        super(props)
        this.state = {
            account: "0x0",
            contractA: null,
            contractB: null,
            isRootDir: null,
            direccion: null,
            direccion2: null,
            saleDate: null,
            idProducto: null,
            ownerAddress: null,
            selectedNFT: null,
            userId: null,
            email: null,
            userEmail: null,
            isChecked: null,
            empresaMapping: null,
            certificadoName: null,
            certificadoId: null,
            loading: false,
            campos: null,
            QRCode: null
        }
    }  


    render(){
        if(this.state.campos != null && this.state.selectedNFT != null && this.state.QRCode != null){
        return (
            <>
<NavBar mail={this.state.email} bearer={this.state.bearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />

{this.state.QRCode != null && (
  <div className="custom-qrcode-container">
    <QRCode value={this.state.QRCode} />
    <button className="custom-qrcode-button" onClick={() => imprimirQR(this.state.QRCode)}>
      {i18n.t('imprimirQR')}
    </button>
  </div>
)}
  
<div className="custom-main-content-2col">
  {/* ID Línea solitario */}
  <button text="Back" className="cewy-button" onClick={(event) => {
                        const url = `/${this.state.empresaMapping}/DPP16/DPPList?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}`
                        window.location.href = url
                    }} >{i18n.t('DPPList')} </button>
  <div className="custom-id-linea">
    <label className="custom-id-label">
      {this.state.campos.filter((campo) => campo.orden == "IDLINEA")[0].nombreCampo}
    </label>
    <p className="custom-id-value">
      {this.state.selectedNFT.idLinea}
    </p>
  </div>

  {/* Contenedor de dos columnas */}
  <div className="custom-columns-container">
    {/* Primera columna */}
    <div className="custom-column-container">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={`campo${i}`}>
          <label className="custom-label-2col">
            {this.state.campos.filter((campo) => campo.orden === `CAMPO${i}`)[0].nombreCampo}
          </label>
          <p className="custom-value-2col">
            {this.state.selectedNFT[`campo${i}`]}
          </p>
        </div>
      ))}

      {Array.from({ length: 6 }, (_, i) => i + 6).map((i) => (
        <div key={`campo${i}`}>
          <label className="custom-label-2col">
            {this.state.campos.filter((campo) => campo.orden === `CAMPO${i}`)[0].nombreCampo}
          </label>
          <p className="custom-value-2col">
            {this.state.selectedNFT[`campo${i}`]}
          </p>
        </div>
      ))}
    </div>
  </div>

  <div className="custom-button-container">
    <button
      id="generate-button"
      className="custom-button-link"
      onClick={() => {
        window.location.href = `/${this.state.empresaMapping}/DPP16/DPPGenerator?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}`;
      }}
    >
      {i18n.t('generateDPP')}
    </button>

    <button
      className="custom-button-link"
      onClick={() => {
        window.location.href = `/listaEmpresas`;
      }}
    >
      {i18n.t('backToEnterprise')}
    </button>
  </div>
</div>

<Footer />
            </>
          );
        }
          

    }

}export default withTranslation()(DPPDisplay);